export default "__VITE_ASSET__BmxSE84W__"